import { axiosApiInstance } from "../App";
import { url } from "./url.service";
const serverUrl = url + "/clientTestimonial";

export const addClientTestimonialsValue = async (formData) => {
    return axiosApiInstance.post(serverUrl + "/", formData);
};
export const getClientTestimonials = async () => {
    return axiosApiInstance.get(`${serverUrl}/`);
};

export const deleteClientTestimonials = async (id) => {
    return axiosApiInstance.delete(`${serverUrl}/deleteById/${id}`);
};
export const updateClientTestimonials = async (id, formData) => {
    return axiosApiInstance.patch(`${serverUrl}/updateById/${id}`, formData);
};
export const updateClientTestimonialsActiveStatus = async (id, formData) => {
    return axiosApiInstance.patch(`${serverUrl}/updateActiveById/${id}`, formData);
};